const config = {
  navTitle: "Tournoi Aramburu | Biarritz Olympique",
  titlePart1: "Tournoi Aramburu",
  titlePart2: "à Biarritz",
  date: "Le Samedi 31 Mai 2025",
  logo: {
    altName: "mycontest.club",
    src: "/logo512.png",
  },
  body: "Bienvenue au Tournoi Aramburu. Ce site web vous accompagnera tout au long de l'événement placé sous le signe du rugby et de l'amitié. Bon tournoi !",
  mainButton: {
    label: "Composition des équipes",
    link: "/ranking",
  },
  secondaryButton: {
    label: "L'asso du BOPB",
    link: "https://biarritzolympiquerugby-asso.com",
  },
  // altLink: {
  //   label: `Retrouver l'édition ${new Date().getFullYear() - 1}`,
  //   link: "https://mycontest.club",
  // },
  altLink: {
    label: null as string | null,
    link: null as string | null,
  },
};

export default config;
